<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Οι αιτήσεις μου</h4>

        <p class="card-title-desc">

        </p>
        <div
          class="row"
          v-if="!isLoading"
        >
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>Α/Α</th>
                  <th>Ημερομηνία Αίτησης</th>
                  <th>Τύπος</th>
                  <th>Διάστημα</th>
                  <th>Μέρες</th>
                  <th>Κατάσταση</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="
                holidayRequests &&
                holidayRequests.results &&
                holidayRequests.results.length > 0">

                <tr
                  v-for="(holidayRequest, index) in holidayRequests.results"
                  :key="index"
                >
                  <th scope="row">
                    <!-- {{ index + 1 }} -->
                    {{
                    holidayRequests.current_page * perPage -
                    perPage +
                    index +
                    1
                    }}
                  </th>

                  <td>{{ holidayRequest.created_at	 }}</td>

                  <td>
                    {{ holidayRequest.oracle_leave_type != null ? 
                    holidayRequest.oracle_leave_type.leave_type : 
                    holidayRequest.holiday_type_title  }}
                  </td>

                  <td>{{ holidayRequest.start_date }} - {{ holidayRequest.end_date }}</td>
                  <td>{{holidayRequest.total_holiday_days}}</td>
                  <td>
                    <span :class="`badge bg-${statusVariant(holidayRequest.status)} font-size-13`">
                      {{ transStatus(holidayRequest.status)}}
                    </span>
                  </td>

                </tr>
              </tbody>

              <tbody v-if=" holidayRequests &&
                holidayRequests.results &&
                holidayRequests.results.length == 0">
                <h2>Δεν έχετε κάνει κάποια αίτηση</h2>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="isLoading">
          <h2>Φόρτωση δεδομένων</h2>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="holidayRequests.count"
          :per-page="perPage"
        ></b-pagination>
      </div>
    </div>
  </div>

</template>


<script>
import session from "../../../../../api/session";
export default {
  data() {
    return {
      holidayRequests: [],
      perPage: 10,
      currentPage: 1,
      page: 1,
      isLoading: true,
    };
  },
  created() {
    this.fetchMyhHolidayRequests();
  },
  watch: {
    currentPage(v) {
      this.page = v;
      this.fetchMyhHolidayRequests();
    },
  },
  methods: {
    fetchMyhHolidayRequests() {
      const params = { page: this.currentPage };
      const searchParams = new URLSearchParams(params);

      session
        .get(`api/my-holiday-requests/?${searchParams.toString()}`)
        .then((resp) => {
          this.holidayRequests = resp.data;
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    transStatus(status) {
      const statusDict = {
        pending: "Εκκρεμής",
        approved: "Eγκρίθηκε",
        declined: "Aπορρίφθηκε",
      };
      return statusDict[status] || "-";
    },
    statusVariant(status) {
      const statusDict = {
        pending: "warning",
        approved: "success",
        declined: "danger",
      };
      return statusDict[status] || "primary";
    },
  },
};
</script>